module.exports = __webpack_public_path__ + "img/0126.6749ac5f.png";